import { routerMiddleware } from "react-router-redux"
import { createStore, applyMiddleware, compose } from "redux"
import createSagaMiddleware from "redux-saga"
import i18n, { DEFAULT_LANGUAGE } from "../i18next"
import { addPersistence } from "./configPersistence"
import history from "./history"
import rootReducer from "./rootReducer"
import rootSaga from "./rootSaga"
import locationChangeMiddleware from "./locationChangeMiddleware"

const sagaMiddleware = createSagaMiddleware()

const router = routerMiddleware(history)

// NOTE: Do not change middleares delaration pattern since rekit plugins may register middlewares to it.
const middlewares = [router, sagaMiddleware]

let devToolsExtension = f => f

/* istanbul ignore if  */
if (process.env.NODE_ENV === "development") {
  const { createLogger } = require("redux-logger")

  const logger = createLogger({ collapsed: true })
  middlewares.push(logger)

  if (window.__REDUX_DEVTOOLS_EXTENSION__) {
    devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__()
  }
}

middlewares.push(locationChangeMiddleware)

export default function configStore(initialState) {
  const storeEnhancer = compose(
    applyMiddleware(...middlewares),
    devToolsExtension,
  )

  const persistingReducer = addPersistence(rootReducer)

  const store = createStore(persistingReducer, initialState, storeEnhancer)

  i18n.changeLanguage(DEFAULT_LANGUAGE)

  /* istanbul ignore if  */
  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept("./rootReducer", () => {
      const rootReducer = require("./rootReducer").default // eslint-disable-line
      store.replaceReducer(rootReducer)
    })
  }

  sagaMiddleware.run(rootSaga)

  return store
}



// WEBPACK FOOTER //
// ./src/common/configStore.js